<div map-container appDisableRightClick>
  @if (spatialSelectionService.screenSize.showReportView) {
    <div report-container (window:resize)="spatialSelectionService.activateReportView()">
      <div class="padding-top" [style.height.px]="spatialSelectionService.screenSize.topEdge"></div>
      <div
        class="padding-left"
        [style.width.px]="spatialSelectionService.screenSize.leftEdge"
        [style.top.px]="spatialSelectionService.screenSize.topEdge"
        [style.bottom.px]="spatialSelectionService.screenSize.topEdge"
      ></div>
      <div
        class="padding-right"
        [style.width.px]="spatialSelectionService.screenSize.leftEdge + spatialSelectionService.screenSize.sidebarWidth"
        [style.top.px]="spatialSelectionService.screenSize.topEdge"
        [style.bottom.px]="spatialSelectionService.screenSize.topEdge"
      ></div>
      <div class="padding-bottom" [style.height.px]="spatialSelectionService.screenSize.topEdge"></div>
    </div>
  }

  <div id="map" (contextmenu)="onRightClick()" (dblclick)="onDoubleClick($event)" data-testid="basemap-map"> </div>
</div>
